import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { Password } from 'primereact/password';
import { useHistory } from 'react-router-dom';
import useWindowDimensions from "../../useWindowDimensions";
import ApiService from "../../services/loginService.js"
import logoPic from '../../img/ikea.jpg';
import './login.css'

const NewLogin = (props) => {
    const history = useHistory();
    const { height, width } = useWindowDimensions();
    const getStyle = () =>{
      let screenHeight = `${height}px`;
      let screenWidth = `${width}px`;
     
    }
    
    const [userId, setUserId] = useState('');
    const [pwd, setPwd] = useState('');
    const [loading, setLoading] = useState(false);
    const doLogin = () => {
        setLoading(true);
        const user = {
            password: pwd,
            userName: userId
        }
        if(user.userName != '' && user.password != ''){
            ApiService.validateUser(user).then(response=>{
                //console.log("Login data : "+response.json())
                props.toast.current.show({
                    severity: 'success', summary: 'Success',
                    detail: 'Login Successful', life: 3000
                });
                localStorage.setItem("token_JWT", response.data.token);
                localStorage.setItem("username", user.userName);
                history.push(`/productInfo`);
                setLoading(false);
            }, error=>{
                props.toast.current.show({
                    severity: 'error', summary: 'Access Denied',
                    detail: 'Login unsuccessful', life: 3000
                });
                setLoading(false);
            });
        }else{
            props.toast.current.show({
                severity: 'error', summary: 'Username or password field should not be empty',
                detail: 'Login unsuccessful', life: 3000
            });
            setLoading(false);
        }
     
    }
useEffect(()=>{
    //console.log("API KEY " +process.env.REACT_APP_MY_API_KEY)
    //console.log("IDENTITY_PROVIDER_SERVICE " + process.env.REACT_APP_API_BASE_URL_IDENTITY_PROVIDER_SERVICE)
   // console.log("TRADER_SERVICE " +process.env.REACT_APP_API_BASE_URL_TRADER_SERVICE)
    //console.log("IFOOD_SERVICE " +process.env.REACT_APP_API_BASE_URL_IFOOD_SERVICE)
    //console.log("PRODUCT_SERVICE " +process.env.REACT_APP_API_BASE_URL_PRODUCT_SERVICE)
}
)
    return (<div style={getStyle()} className="p-grid p-justify-center p-align-center ">
         
         <div className="p-col-5 p-md-5 firstPartColor">
         <div className="newImageIconCss">
            {<img src="https://in.accounts.ikea.com/resources/static/logo.svg" alt="abc.png" width="100px" height ="auto"></img>}
        </div>
        <div className ="p-col-6 p-offset-4 center-screen  ">
           
              <h1> <span className="firstTextCss"> Login</span>
               <span className="SecondTextCss"> to your </span>
               <span className="SecondTextCss">ITDT account.</span> </h1>
          
           
            
        </div>
        <div className ="p-col-6 p-offset-4">
           
           <h4 className="normalText"> To Access the ITDT Feature please login with your credentials.
           </h4>
       
        
         
     </div>

         </div>
         <div className="p-col-7 p-md-7 ">
         <div className="p-fluid">      
                    <div className="p-grid">
                    {/* <div className="p-col-2 p-offset-2 textLabel">
                    <label className="labelCss">Username</label>

                    </div> */}
                    <div className="p-col-7 p-offset-2">
                        <span className="p-input-icon-right  p-float-label">
                            <i className="pi pi-user" />
                            <InputText className="" value={userId} onChange={(e) => setUserId(e.target.value)}
                               />
                            <label htmlFor="in">Username</label>

                        </span>
                        </div>
                    </div>
                    <br></br>
                    <div className="p-grid">
                    {/* <div className="p-col-2 p-offset-2 textLabel">
                    <label className="labelCss">Password</label>

                    </div> */}
                    <div className="p-col-7 p-offset-2">
                        <span className="p-input-icon-left p-float-label  ">
                        
                            <Password  className ="" feedback={false} value={pwd} onChange={(e) => setPwd(e.target.value)} toggleMask  />
                            <label className="labelText">Password</label>
                        </span>
                    </div>
                    </div>
                    <div className="p-grid">
                    <div className="p-col-7 p-offset-2">
                        <Button className ="buttonColorOne" label="Login" icon="pi pi-check" 
                        iconPos="right"
                            loading={loading} onClick={() => doLogin()} />
                            </div>
                    </div>
                </div>

         </div>

         

    </div>);

}

export default NewLogin;